import { combineReducers } from 'redux';
import taxonomyFilters from './taxonomyFilters/reducer';

export default combineReducers({
  taxonomyFilters,
});
